import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { CheckIcon, SparklesIcon, PhoneIcon, MailIcon, MapPinIcon, WhatsAppIcon, InstagramIcon, FacebookIcon, TruckIcon, PackageIcon } from './Icons';

function Footer({ setPolicyModal, setPage }) {
    const { t } = useTranslation();
    const year = new Date().getFullYear();

    const handlePolicyClick = (e, type) => {
        e.preventDefault();
        setPolicyModal(type);
    };

    const handleScrollClick = (e, targetId) => {
        e.preventDefault();
        // Always go back to home page first if we're on buy/details
        if (setPage) setPage('home');

        // Use a slight delay to allow React to render the home page components
        setTimeout(() => {
            if (targetId === 'top') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                const element = document.getElementById(targetId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }, 100);
    };

    return (
        <footer className="footer">
            <div className="footer-inner reveal-on-scroll">
                {/* Brand column */}
                <div className="footer-brand">
                    <div
                        className="footer-logo"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => handleScrollClick(e, 'top')}
                    >
                        <SparklesIcon /> <span>VITA</span>PLEX
                    </div>
                    <p>
                        {t('footer.about')}
                    </p>
                    <div className="footer-badges">
                        <span className="f-badge"><CheckIcon /> {t('footer.sulfateFree')}</span>
                        <span className="f-badge"><CheckIcon /> {t('footer.parabenFree')}</span>
                        <span className="f-badge"><CheckIcon /> {t('footer.crueltyFree')}</span>
                    </div>
                </div>

                {/* Links */}
                <div className="footer-links-col">
                    <h4>{t('footer.links.title')}</h4>
                    <ul>
                        <li><a href="#!" onClick={(e) => handleScrollClick(e, 'top')}>{t('nav.home')}</a></li>
                        <li><a href="#bundles" onClick={(e) => handleScrollClick(e, 'bundles')}>{t('nav.shop')}</a></li>
                        <li><a href="#benefits" onClick={(e) => handleScrollClick(e, 'benefits')}>{t('nav.benefits')}</a></li>
                        <li><a href="#faq" onClick={(e) => handleScrollClick(e, 'faq')}>{t('nav.faq')}</a></li>
                    </ul>
                </div>

                {/* Legal column */}
                <div className="footer-links-col">
                    <h4>{t('footer.legal.title')}</h4>
                    <ul>
                        <li><a href="#!" onClick={(e) => handlePolicyClick(e, 'privacy')}>{t('footer.legal.privacy')}</a></li>
                        <li><a href="#!" onClick={(e) => handlePolicyClick(e, 'terms')}>{t('footer.legal.terms')}</a></li>
                        <li><a href="#!" onClick={(e) => handlePolicyClick(e, 'shipping')}>{t('footer.legal.shipping')}</a></li>
                    </ul>
                </div>

                {/* Contact column */}
                <div className="footer-links-col">
                    <h4>{t('nav.contact')}</h4>
                    <ul className="footer-contact-list">
                        <li><span><PhoneIcon /></span> <span className="contact-number">{t('contact.info.phone')}</span></li>
                        <li><span><MailIcon /></span> {t('contact.info.email')}</li>
                        <li><span><MapPinIcon /></span> {t('contact.info.location')}</li>
                    </ul>
                </div>

                {/* Social column */}
                <div className="footer-links-col">
                    <h4>{t('common.followUs')}</h4>
                    <div className="social-links">
                        <a href="https://wa.me/212632466957" aria-label="WhatsApp"><WhatsAppIcon /></a>
                        <a href="https://www.instagram.com/vitaplex.shop" aria-label="Instagram"><InstagramIcon /></a>
                        <a href="https://www.facebook.com/share/189Tveyi7w/" aria-label="Facebook"><FacebookIcon /></a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom reveal-on-scroll reveal-delay-1">
                <div className="footer-divider"></div>
                <div className="footer-trust-row">
                    <div className="trust-item">
                        <TruckIcon />
                        <span>CTM Messagerie</span>
                    </div>
                    <div className="trust-item">
                        <PackageIcon />
                        <span>Aramex Express</span>
                    </div>
                    <div className="trust-item">
                        <CheckIcon />
                        <span>{t('common.secureCheckout')}</span>
                    </div>
                </div>
                <div className="footer-divider"></div>
                <div className="footer-bottom-row">
                    <p>{t('footer.copyright', { year })}</p>
                    <div className="footer-bottom-links">
                        <a href="#!" onClick={(e) => handlePolicyClick(e, 'privacy')}>{t('footer.legal.privacy')}</a>
                        <a href="#!" onClick={(e) => handlePolicyClick(e, 'terms')}>{t('footer.legal.terms')}</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
